import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 200;

/**
 * Scarcity trigger: an almost-full progress bar showing the remaining
 * spots at the promotional price.
 */
export function ScarcityBar() {
  const [remaining, setRemaining] = useState(14);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev > 6 ? prev - 1 : prev);
    }, 45000);
    return () => window.clearInterval(interval);
  }, []);
  const claimed = TOTAL_SPOTS - remaining;
  const percent = Math.round(claimed / TOTAL_SPOTS * 100);
  return <div className="w-full rounded-2xl border border-red-200 bg-red-50 p-4 sm:p-5" data-id="element-51" data-mp="226tvewzo3xzs">
      <div className="mb-2 flex items-center justify-center gap-2 text-center" data-id="element-52" data-mp="274vc5b9mfl83">
        <FlameIcon className="h-4 w-4 shrink-0 text-red-600" aria-hidden="true" data-id="element-53" data-mp="276zpejtetwl1" />
        <p className="text-[12px] font-extrabold uppercase leading-tight tracking-wide text-red-700 sm:text-sm" data-id="element-54" data-mp="cm78jqfabbw">
          Solo quedan {remaining} cupos al precio promocional
        </p>
      </div>
      <div className="h-3 w-full overflow-hidden rounded-full bg-red-200" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos reclamados al precio promocional" data-id="element-55" data-mp="33ks7l97my5oc">
        <div className="h-full rounded-full bg-red-600 transition-all duration-700" style={{
        width: `${percent}%`
      }} data-id="element-56" data-mp="38empc73okaks" />
      </div>
      <p className="mt-2 text-center text-[11px] font-semibold text-red-700/80 sm:text-xs" data-id="element-57" data-mp="2gmf9v9zwv47z">
        {claimed} de {TOTAL_SPOTS} cupos ya reclamados hoy
      </p>
    </div>;
}